import type { WorkspaceSummary } from '@/lib/api/generated/model';

export type WorkspaceSection = 'yours' | 'shared' | 'others';

/**
 * Which section of the home page a workspace belongs in (spec 188, decision Q26), or
 * `null` when access is not enforced and the page keeps its one list.
 *
 * Yours: you are an owner or a member — or, for a workspace from before membership
 * was recorded, you created it. Shared: an Organization workspace you are not in.
 * Others: a Private workspace you are not in, which only an org admin is shown.
 */
export function sectionOf(
  entry: WorkspaceSummary,
  currentUserId: string | undefined,
): WorkspaceSection | null {
  const access = entry.access;
  if (!access?.enforced) return null;
  if (access.role != null) return 'yours';
  if (currentUserId !== undefined && entry.created_by?.id === currentUserId) {
    return 'yours';
  }
  return entry.visibility === 'organization' ? 'shared' : 'others';
}
